import { SvgIcon, SvgIconProps } from '@mui/material';

const Send01Icon = (props: SvgIconProps) => (
  <SvgIcon
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_22144_55095)'>
      <path
        d='M6.99903 9.00012L13.999 2.00012M7.08408 9.21883L8.83616 13.7242C8.99051 14.1211 9.06768 14.3195 9.17888 14.3774C9.27528 14.4277 9.39012 14.4277 9.48658 14.3776C9.59785 14.3198 9.67525 14.1215 9.83007 13.7247L14.2236 2.46625C14.3634 2.10813 14.4333 1.92907 14.395 1.81465C14.3618 1.71528 14.2839 1.6373 14.1845 1.60411C14.0701 1.56588 13.891 1.63576 13.5329 1.77552L2.2744 6.16908C1.87768 6.32389 1.67933 6.4013 1.62152 6.51257C1.57141 6.60903 1.57148 6.72386 1.6217 6.82026C1.67964 6.93146 1.87809 7.00864 2.27498 7.16299L6.78032 8.91506C6.86089 8.94639 6.90117 8.96206 6.93509 8.98625C6.96515 9.0077 6.99145 9.03399 7.01289 9.06406C7.03709 9.09798 7.05275 9.13826 7.08408 9.21883Z'
        stroke='#1C1F1F'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
    </g>
    <defs>
      <clipPath id='clip0_22144_55095'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default Send01Icon;
